module.exports = __webpack_public_path__ + "media/images/landing/persons/veronika-duricova-4d6229ffb254d7ea1e7cbca7099738dc.jpeg";